import React from "react";
import Navbar from "../components/Navbar";

const AppLayout = ({ children }) => {
	return (
		<div className="min-h-screen bg-slate-100">
			<Navbar />
			<main className="pt-14 lg:pt-16 pl-0 lg:pl-56">
				<div className="px-4 sm:px-6 py-4">{children}</div>
			</main>
		</div>
	);
};

export default AppLayout;
